namespace Dataport.OD.ErAnMiZuWohngeld {
  export class ChatBot {
    readonly target: JQuery<HTMLBodyElement> = $<HTMLBodyElement>('body');

    async addChatBotElement(config) {
      console.log('AddChatBotElement');

      const genericChatBot = $('<chatbot-widget />').attr({
        token: config['Token'],
        caption: config['Caption'],
        bundesland: config['Bundesland'],
        model: config['Model'],
        lang: config['Language'],
        shortname: config['Shortname'],
      });

      this.target.append(genericChatBot);

      setTimeout(() => {
        if (config['ComponentUrl']) {
          const script = document.createElement('script');
          script.src = config['ComponentUrl'];
          document.body.appendChild(script);
        } else {
          console.error('ComponentUrl is missing in config');
        }
      });
    }

    async initChatBot() {
      const src = $<HTMLScriptElement>('script')
        .filter((n: number, s: HTMLScriptElement) => s.src.toLowerCase().endsWith('chatbot.js'))
        .attr('src');
      const odBaseAddress = src?.slice(0, src.indexOf('Scripts/'));
      console.log('initChatBot', src, odBaseAddress);
      // document.getElementsByTagName('script')
      try {
        const response = await fetch(odBaseAddress + 'ChatBot/ChatBotConfig', { method: 'POST' });
        if (!response.ok) {
          console.error(response);
          return;
        }

        const config = await response.json();

        if (!config['IsActive']) {
          console.info('Chatbot is not active');
          return;
        }

        await this.addChatBotElement(config);
      } catch (e) {
        console.warn(e);
      }
    }
  }

  function waitForjQuery(callback: () => void, timeout: number = 5000): void {
    const check = (): void => {
      if (window['$']) {
        callback();
      } else if (timeout > 0) {
        setTimeout(check, 100);
      } else {
        console.error('jQuery ($-Operator) wurde nicht geladen.');
      }
    };
    setTimeout(check, 100);
  }

  waitForjQuery(async () => {
    const bot = new ChatBot();
    await bot.initChatBot();
  });
}
